module.exports = __webpack_public_path__ + "7799dece2c79854f63f09e7dfa528b88.jpg";


//////////////////
// WEBPACK FOOTER
// ./application/adminlte/dist/img/boxed-bg.jpg
// module id = 276
// module chunks = 0